'use client';

import { useEffect } from 'react';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

const UTM_STORAGE_KEYS = [...UTM_PARAMS, 'landing_page', 'referrer'] as const;

export type UtmData = Record<(typeof UTM_STORAGE_KEYS)[number], string>;

export const captureUtmData = () => {
	if (typeof window === 'undefined') return;

	const params = new URLSearchParams(window.location.search);

	const hasUtmParams = UTM_PARAMS.some(key => params.has(key));

	if (hasUtmParams)
		UTM_PARAMS.forEach(key => {
			const value = params.get(key);

			if (value) sessionStorage.setItem(key, value);
		});

	if (!sessionStorage.getItem('landing_page'))
		sessionStorage.setItem('landing_page', window.location.pathname);

	if (!sessionStorage.getItem('referrer')) sessionStorage.setItem('referrer', document.referrer);
};

export const getUtmData = (): UtmData => {
	if (typeof window === 'undefined')
		return UTM_STORAGE_KEYS.reduce((acc, key) => ({ ...acc, [key]: '' }), {} as UtmData);

	return UTM_STORAGE_KEYS.reduce(
		(acc, key) => ({ ...acc, [key]: sessionStorage.getItem(key) || '' }),
		{} as UtmData
	);
};

export const clearUtmData = () => {
	if (typeof window === 'undefined') return;

	UTM_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));
};

export const useUtmTracking = () => {
	useEffect(() => {
		captureUtmData();
	}, []);
};
